<script lang="ts">
  import { onMount } from 'svelte';
  import SettingsLayout from '../../components/SettingsLayout.svelte';
  import { fetchAuditLog, type AuditRow } from '../../lib/admin-api';
  import { fmtRelative } from '../../lib/format';

  let rows = $state<AuditRow[]>([]);
  let loading = $state(true);
  let err = $state<string | null>(null);

  onMount(async () => {
    try {
      rows = await fetchAuditLog(7);
    } catch (e) {
      err = e instanceof Error ? e.message : String(e);
    } finally {
      loading = false;
    }
  });

  function actionClass(action: string): string {
    if (action.includes('failed') || action.includes('disable')) return 'text-red-700';
    if (action.includes('login.success') || action.includes('create')) return 'text-emerald-700';
    return 'text-[var(--color-pu-3)]';
  }
</script>

<SettingsLayout active="audit">
  <div class="mx-auto max-w-[1200px]">
    <header class="mb-5">
      <h1 class="text-xl font-semibold leading-tight">Audit log</h1>
      <p class="mt-1 text-[12px] text-[var(--color-text-muted)]">
        Усі дії команди · логуються через audit middleware · зберігаються 1 рік
      </p>
    </header>

    {#if loading}
      <div class="py-20 text-center text-sm text-[var(--color-text-muted)]">Завантаження…</div>
    {:else if err}
      <div class="rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-700">{err}</div>
    {:else}
      <div class="overflow-hidden rounded-lg border border-[var(--color-border-3)]">
        <table class="w-full text-xs">
          <thead class="bg-[var(--color-bg-3)]">
            <tr class="text-[10px] uppercase tracking-[1px] text-[var(--color-text-muted-2)]">
              <th class="text-left px-3 py-2 font-bold">Час</th>
              <th class="text-left px-3 py-2 font-bold">Actor</th>
              <th class="text-left px-3 py-2 font-bold">Action</th>
              <th class="text-left px-3 py-2 font-bold">Target</th>
              <th class="text-left px-3 py-2 font-bold">IP</th>
            </tr>
          </thead>
          <tbody>
            {#each rows as r (r.id)}
              <tr class="border-t border-[var(--color-border-3)]">
                <td class="px-3 py-2 text-[11px] text-[var(--color-text-muted)]">{fmtRelative(r.occurredAt)}</td>
                <td class="px-3 py-2">
                  {#if r.actorEmail}
                    <span class="font-semibold">{r.actorEmail}</span>
                    <span class="ml-1 rounded-full bg-purple-100 px-1.5 py-0.5 text-[9.5px] font-bold text-purple-700">{r.actorRole}</span>
                  {:else}
                    <span class="text-[var(--color-text-muted)] text-[11px]">— system</span>
                  {/if}
                </td>
                <td class="px-3 py-2">
                  <code class="font-mono {actionClass(r.action)} text-[11px]">{r.action}</code>
                </td>
                <td class="px-3 py-2 text-[10.5px] text-[var(--color-text-muted)]">{r.targetType}{r.targetId ? `: ${r.targetId.slice(0, 8)}` : ''}</td>
                <td class="px-3 py-2 font-mono text-[10.5px] text-[var(--color-text-muted)]">{r.ip ?? '—'}</td>
              </tr>
            {/each}
            {#if rows.length === 0}
              <tr><td colspan="5" class="px-3 py-12 text-center text-xs text-[var(--color-text-muted)]">Поки немає записів за 7 днів</td></tr>
            {/if}
          </tbody>
        </table>
      </div>
    {/if}
  </div>
</SettingsLayout>
